// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.menu {
  position: fixed;
  top: 85px;
  left: 0;
  display: flex;
  flex-direction: column;
  background-color: #2b323b;
  border-right: 1px solid #334155;
  padding: 25px 10px;
  width: 250px;
  border-top-right-radius: 34px;
  z-index: 1000;
  transition: transform 0.3s ease;
  transform: translateX(-275px);
  box-shadow: 2px 0 5px rgba(0, 0, 0, 0.3);
  height: calc(100vh - 60px);
  color: #e2e8f0;
}

.menu.open {
  transform: translateX(0);
}

.menu h2 {
  margin-top: 0;
  color: #f1f5f9;
  font-size: 0.95rem;
  font-weight: 600;
  text-transform: uppercase;
  text-align: center;
  border-bottom: 1px solid #334155;
  padding-bottom: 10px;
  margin-bottom: 20px;
}

.menu ul {
  list-style: none;
  margin: 0;
  flex-grow: 1;
  overflow-y: auto;
  display: flex;
  margin-top: 25px;
  flex-direction: column;
  padding-top: 10px;
  padding-bottom: 60px;
}

.menu ul li {
  flex-shrink: 0;
  margin-bottom: 8px;
}

.menu ul li button {
  background: none;
  border: none;
  cursor: pointer;
  color: #e2e8f0;
  text-align: left;
  padding: 12px;
  width: 100%;
  display: flex;
  align-items: center;
  border-radius: 10px;
  font-size: 0.95rem;
  transition: background-color 0.2s ease-in-out, color 0.2s ease-in-out;
}

.menu ul li button:hover {
  background-color: rgba(59, 130, 246, 0.1); /* azul claro en hover */
  color: #3b82f6;
}

.menu ul li button:focus {
  outline: none;
  box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.5);
}

/* Botón de nuevo chat */
.new-chat-button {
  background-color: #125886;
  color: #f8fafc;
  padding: 12px 15px;
  border: none;
  border-radius: 20px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease-in-out;
  font-size: 1rem;
  font-weight: 600;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.2);
  width: 100%;
}

.new-chat-button:hover {
  background-color: #0e3c4e4b;
  transform: scale(1.01);
}

.new-chat-button:active {
  transform: scale(0.95);
}

.new-chat-button .button-text {
  margin-left: 8px;
}

/* Scrollbar oscuro */
.menu::-webkit-scrollbar {
  width: 6px;
}

.menu::-webkit-scrollbar-thumb {
  background-color: #3b82f6;
  border-radius: 4px;
}

.menu::-webkit-scrollbar-track {
  background: #0f172a;
}
`, "",{"version":3,"sources":["webpack://./src/components/chat/ChatSidebar/ChatSidebar.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,SAAS;EACT,OAAO;EACP,aAAa;EACb,sBAAsB;EACtB,yBAAyB;EACzB,+BAA+B;EAC/B,kBAAkB;EAClB,YAAY;EACZ,6BAA6B;EAC7B,aAAa;EACb,+BAA+B;EAC/B,6BAA6B;EAC7B,wCAAwC;EACxC,0BAA0B;EAC1B,cAAc;AAChB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,gCAAgC;EAChC,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,gBAAgB;EAChB,sBAAsB;EACtB,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,aAAa;EACb,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,qEAAqE;AACvE;;AAEA;EACE,yCAAyC,EAAE,wBAAwB;EACnE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,6CAA6C;AAC/C;;AAEA,wBAAwB;AACxB;EACE,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,wCAAwC;EACxC,WAAW;AACb;;AAEA;EACE,2BAA2B;EAC3B,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,qBAAqB;AACrB;EACE,UAAU;AACZ;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB","sourcesContent":[".menu {\n  position: fixed;\n  top: 85px;\n  left: 0;\n  display: flex;\n  flex-direction: column;\n  background-color: #2b323b;\n  border-right: 1px solid #334155;\n  padding: 25px 10px;\n  width: 250px;\n  border-top-right-radius: 34px;\n  z-index: 1000;\n  transition: transform 0.3s ease;\n  transform: translateX(-275px);\n  box-shadow: 2px 0 5px rgba(0, 0, 0, 0.3);\n  height: calc(100vh - 60px);\n  color: #e2e8f0;\n}\n\n.menu.open {\n  transform: translateX(0);\n}\n\n.menu h2 {\n  margin-top: 0;\n  color: #f1f5f9;\n  font-size: 0.95rem;\n  font-weight: 600;\n  text-transform: uppercase;\n  text-align: center;\n  border-bottom: 1px solid #334155;\n  padding-bottom: 10px;\n  margin-bottom: 20px;\n}\n\n.menu ul {\n  list-style: none;\n  margin: 0;\n  flex-grow: 1;\n  overflow-y: auto;\n  display: flex;\n  margin-top: 25px;\n  flex-direction: column;\n  padding-top: 10px;\n  padding-bottom: 60px;\n}\n\n.menu ul li {\n  flex-shrink: 0;\n  margin-bottom: 8px;\n}\n\n.menu ul li button {\n  background: none;\n  border: none;\n  cursor: pointer;\n  color: #e2e8f0;\n  text-align: left;\n  padding: 12px;\n  width: 100%;\n  display: flex;\n  align-items: center;\n  border-radius: 10px;\n  font-size: 0.95rem;\n  transition: background-color 0.2s ease-in-out, color 0.2s ease-in-out;\n}\n\n.menu ul li button:hover {\n  background-color: rgba(59, 130, 246, 0.1); /* azul claro en hover */\n  color: #3b82f6;\n}\n\n.menu ul li button:focus {\n  outline: none;\n  box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.5);\n}\n\n/* Botón de nuevo chat */\n.new-chat-button {\n  background-color: #125886;\n  color: #f8fafc;\n  padding: 12px 15px;\n  border: none;\n  border-radius: 20px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.3s ease-in-out;\n  font-size: 1rem;\n  font-weight: 600;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.2);\n  width: 100%;\n}\n\n.new-chat-button:hover {\n  background-color: #0e3c4e4b;\n  transform: scale(1.01);\n}\n\n.new-chat-button:active {\n  transform: scale(0.95);\n}\n\n.new-chat-button .button-text {\n  margin-left: 8px;\n}\n\n/* Scrollbar oscuro */\n.menu::-webkit-scrollbar {\n  width: 6px;\n}\n\n.menu::-webkit-scrollbar-thumb {\n  background-color: #3b82f6;\n  border-radius: 4px;\n}\n\n.menu::-webkit-scrollbar-track {\n  background: #0f172a;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
